import { getConsolidatedTranslations } from 'core/utils/parsers';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
    Box,
    Tooltip,
    Typography
} from '@mui/material';
// My Components
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';

import { DigitalShelfContext } from '../../../contexts/DigitalShelf';
import { handleCoordAlertInfo } from '../../utils/colors';
import CustomCardContent from './CustomCardContent';

export default function ProductMetadata(props) {
    const {
        currencySymbol,
        clientFormats,
    } = props;
    const { t } = useTranslation();
    const [alertsIcons, setAlertsIcons] = useState(null);
    // Context
    const {
        dateState,
        selectedStore,
        selectedProduct,
    } = useContext(DigitalShelfContext);


    useEffect(() => {
        if (selectedProduct) {
            const iconInfo = handleCoordAlertInfo(selectedProduct);
            setAlertsIcons(
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                    {iconInfo.map((icon, index) => (
                        <Tooltip
                            key={`product-metadata-icon-${index}`}
                            title={
                                getConsolidatedTranslations(t, selectedStore?.chain_name, icon.title, 'Walls', icon.title)
                            }>
                            <Typography sx={{
                                p: '3px',
                                borderRadius: '5px',
                                backgroundColor: icon.colorInfo.color
                            }}>
                                <IconComponent
                                    iconName={icon.iconName}
                                    width={'1.4em'}
                                    height={'1.4em'}
                                    sx={{ fontSize: '6em' }}
                                />
                            </Typography>
                        </Tooltip>
                    ))}
                </Box>
            )
        }
    }, [JSON.stringify(selectedProduct)])

    // handlers
    const checkIconName = product => {
        let iconName = 'stock';
        if (product.hasOwnProperty('stockout')) {
            // promotions can be isolated with this condition
            if (product.stockout) iconName = 'stock-out';
            else if (product.price_difference) iconName = 'price-difference';
            else if (product.inactive_promotion) iconName = 'inactive-promo';
            else if (product.landmark_type) iconName = 'location';
            else if (product.spread_to_fill) iconName = 'stock-out';
        } else {
            iconName = 'promotion';
        }
        return iconName;
    };

    return (
        (selectedProduct?.texts || selectedProduct?.landmark ||
            (selectedProduct && checkIconName(selectedProduct) === 'promotion' && selectedProduct?.code)) ? (
            <Box sx={{ color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {/* Title: product name or landmark */}
                <Typography
                    gutterBottom
                    sx={{ fontWeight: 'bold', mt: 0.5, px: 0, color: 'white' }}>
                    {selectedProduct?.texts
                        ? selectedProduct?.texts
                        : selectedProduct?.landmark
                            ? getConsolidatedTranslations(
                                t,
                                selectedStore?.chain_name,
                                'landmark',
                                'Walls',
                                'landmark',
                            ) +
                            ': ' +
                            selectedProduct?.landmark
                            : selectedProduct.description}
                </Typography>
                {/* Metadata */}
                <CustomCardContent
                    selectedProduct={selectedProduct}
                    selectedStore={selectedStore}
                    dateState={dateState}
                    clientFormats={clientFormats}
                    currencySymbol={currencySymbol}
                    alertsIcons={alertsIcons}
                />
            </Box>
        )
            :
            (selectedProduct?.isPromotion ?
                (<Box sx={{ color: 'white' }}>
                    <Box sx={{
                        height: '20em', width: '100%', border: '1px solid #16181a', mb: 3, borderRadius: '5px', boxShadow: 1,
                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}>
                        <h3>
                            {t('cws_app.general.no_master_data', 'No master data available')}
                        </h3>
                    </Box>
                </Box>)
                :
                (<Box sx={{ color: 'white' }}>
                    <Box sx={{
                        minHeight: '20em', width: '100%', border: '1px solid #16181a', borderRadius: '5px', boxShadow: 1,
                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}>
                        <h3>
                            {t('cws_app.general.No_data', 'No data to display.')}
                        </h3>
                    </Box>
                </Box>)
            )
    )
}
